























































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { ELetterStatus, EUserPermissions, IUser } from '@zunta/configurations'
import Accordion from '@/components/Accordion.vue'
import Select from '@/components/Select.vue'
import Icon from '@/components/Icon.vue'
import SearchInput from '@/components/inputs/SearchInput.vue'
import DateInput from '@/components/inputs/DateInput.vue'
import CircleChart from '@/components/chart/CircleChart.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Tabs from '@/components/layout/Tabs.vue'
import Confirm from '@/components/Confirm.vue'
import StatementsMailSuccessModal from './components/StatementsMailSuccessModal.vue'
import StatementsMailCompleteModal from './components/StatementsMailCompleteModal.vue'
import { StatementModule } from '@/store/modules/statement.module'
import { LETTERS_MAILED_STATUSES, LETTERS_STATUSES_LABEL_MAP, LETTERS_UNMAILED_STATUSES, STATEMENT_STATUSES_LABEL_MAP } from '@/constants'
import TrackingMail from '@/components/TrackingMail.vue'
import Api from '@/api'
import { User } from '@/classes/User'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import GoBack from '@/components/GoBack.vue'
import Card from '@/components/Card.vue'
import CircleChartWithDescriptions from '@/components/chart/CircleChartWithDescriptions.vue'
import { LettersModule } from '@/store/modules/letters.module'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  components: {
    ModalV2,
    CircleChartWithDescriptions,
    Card,
    GoBack,
    ResidentLabel,
    TrackingMail,
    Accordion,
    Select,
    Icon,
    DateTimeLabel,
    SearchInput,
    DateInput,
    CircleChart,
    Tabs,
    Confirm,
    StatementsMailSuccessModal,
    StatementsMailCompleteModal
  }
})
export default class ManagementMailingsLettersBatch extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  letterModuleInstance: LettersModule = getModule(LettersModule, this.$store)
  user: User = Api.getUser() as User

  EUserPermissions: any = EUserPermissions
  ELetterStatus: any = ELetterStatus

  sentMailResult: { deliverToRoom: number, printedStatementUser: IUser } | null = null

  showStatementsMailSuccessMessage: boolean = false
  showStatementsMailCompleteMessage: boolean = false
  showConfirmModal: boolean = false
  isMailing: boolean = false

  get tabs () {
    return [
      {
        key: 'management-mailings-letters-batch-unmailed',
        value: { name: 'management-mailings-letters-batch-unmailed' },
        content: 'Unmailed'
      },
      {
        key: 'management-mailings-letters-batch-mailed',
        value: { name: 'management-mailings-letters-batch-mailed' },
        content: 'Mailed'
      }
    ]
  }

  get dashboardUnmailedData () {
    return [
      {
        value: this.dashboardStatistics[ELetterStatus.READY_TO_MAIL],
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.READY_TO_MAIL],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[ELetterStatus.NEEDS_FIX],
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.NEEDS_FIX],
        color: 'var(--status-incomplete-color)'
      },
      {
        value: this.dashboardStatistics[ELetterStatus.NEEDS_REVIEW],
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.NEEDS_REVIEW],
        color: 'var(--status-error-color)'
      },
      {
        value: this.dashboardStatistics[ELetterStatus.RETURNED],
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.RETURNED],
        color: 'var(--status-error-color)'
      },
      {
        value: this.dashboardStatistics[ELetterStatus.EMAIL_RETURNED],
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.EMAIL_RETURNED],
        color: 'var(--status-error-color)'
      },
      {
        value: (this.dashboardStatistics[ELetterStatus.DO_NOT_BILL_RETURNED] + this.dashboardStatistics[ELetterStatus.DO_NOT_BILL_EMAIL_RETURNED]),
        text: LETTERS_STATUSES_LABEL_MAP[ELetterStatus.DO_NOT_BILL],
        color: 'var(--status-progress-color)'
      }
    ]
  }

  get dashboardMailedData () {
    return [
      {
        value: this.dashboardStatistics[this.ELetterStatus.DELIVERED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.READY_TO_MAIL],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.PROCESSED_FOR_DELIVERY],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.PROCESSED_FOR_DELIVERY],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.REROUTED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.REROUTED],
        color: 'var(--status-incomplete-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.IN_TRANSIT],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.IN_TRANSIT],
        color: 'var(--status-info-color)'
      }, {
        value: this.dashboardStatistics[this.ELetterStatus.IN_PROCESS],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.IN_PROCESS],
        color: 'var(--status-progress-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.IN_LOCALAREA],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.IN_LOCALAREA],
        color: 'var(--status-default-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.PRINTED_LOCALLY],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.PRINTED_LOCALLY],
        color: 'var(--status-info-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.EMAILED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.EMAILED],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.ELetterStatus.PENDING],
        text: STATEMENT_STATUSES_LABEL_MAP[this.ELetterStatus.PENDING],
        color: 'var(--status-info-color)'
      }
    ]
  }

  get mailedStatusesCount () {
    if (this.dashboardStatistics) {
      let count = 0
      Object.values(LETTERS_MAILED_STATUSES).forEach((mailedStatus: ELetterStatus) => {
        count += this.dashboardStatistics[mailedStatus]
      })
      return count.toString()
    }
    return 0
  }

  get unmailedStatusesCount () {
    if (this.dashboardStatistics) {
      let count = 0
      Object.values(LETTERS_UNMAILED_STATUSES).forEach((unmailedStatus: ELetterStatus) => {
        count += this.dashboardStatistics[unmailedStatus]
      })
      return count.toString()
    }
    return 0
  }

  get selectedBatch () {
    return this.$store.state.statement.selectedBatch
  }

  get mailStatements () {
    return this.$store.state.letter.mailStatements
  }

  get mailStatementsUser () {
    if (!this.$store.state.statement.mailStatements.printedStatementUser) {
      return ''
    }
    const user = this.$store.state.statement.mailStatements.printedStatementUser
    return `${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`
  }

  get mailStatementsSum () {
    return this.mailStatements ? this.mailStatements.deliverToRoom + this.mailStatements.paperless + this.mailStatements.mailed : 0
  }

  get batchID () {
    return this.$route.params.id
  }

  get dashboardStatistics () {
    return this.$store.state.letter.lettersStatistics
  }

  beforeMount () {
    if (this.$route.name === 'management-mailings-batch') {
      this.$router.push({ name: 'management-mailings-letters-batch-unmailed' })
    }
  }

  async mounted () {
    await this.letterModuleInstance.fetchLettersBatchStatistics(this.batchID)
  }

  beforeDestroy () {
    this.letterModuleInstance.resetStatistics()
  }

  closeStatementsMailCompleteModal () {
    this.showStatementsMailCompleteMessage = false
  }

  closeStatementsMailSuccessModal () {
    this.showStatementsMailSuccessMessage = false
  }

  closeConfirmMail () {
    this.showConfirmModal = false
    this.statementModuleInstance.clearMailStatements()
  }

  openSendMailConfirm () {
    this.statementModuleInstance.fetchMailStatements(this.batchID)
    this.showConfirmModal = true
  }

  goToPage (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  goBack () {
    this.$locationManager.goBack({ name: 'management-mailings' })
  }
}
